module.exports = __webpack_public_path__ + "img/ic24ArrowR.91415f20.svg";